import * as React from 'react';
import { useHistory } from 'react-router';
import { AppContext } from '../AppContext';
import { Button } from '../components/Button';
import { LogoutButton } from '../components/LogoutButton';
import { textOrNotSet } from '../components/NotSet';
import { PageHeader } from '../components/PageHeader';
import { getAuthorityName } from '../components/AuthorityLabel';
import { formatDate } from '../utils/DateHelper';
import './MyPage.css';

/**
 * マイページの画面。ヘッダーのユーザーメニューの「マイページ」から開く。
 * パスワードの変更は、他の項目と同じ並びの「パスワード」の行に置き、探さずに見つけられるようにする。
 * standard のマイページにあったログアウトのボタンも表の下に置く（ヘッダーの右上のボタンと同じ動き）。
 */
export const MyPage: React.FC = function () {
  const appContext = React.useContext(AppContext);
  const history = useHistory();

  if (!appContext || !appContext.state.me) {
    throw new Error();
  }

  const me = appContext.state.me;

  return (
    <div className="MyPage">
      <PageHeader title="マイページ" />
      <dl className="MyPage-details">
        <dt className="MyPage-term">名前</dt>
        <dd className="MyPage-description">{textOrNotSet(me.name)}</dd>
        <dt className="MyPage-term">ID</dt>
        <dd className="MyPage-description">{textOrNotSet(me.screenId)}</dd>
        <dt className="MyPage-term">所属部署</dt>
        <dd className="MyPage-description">{textOrNotSet(me.department)}</dd>
        <dt className="MyPage-term">権限</dt>
        <dd className="MyPage-description">{getAuthorityName(me.authority.level)}</dd>
        <dt className="MyPage-term">作成日</dt>
        <dd className="MyPage-description">{formatDate(me.created)}</dd>
        <dt className="MyPage-term">パスワード</dt>
        <dd className="MyPage-description MyPage-password">
          {/* パスワードの値は表示できないので、設定済みであることを伏せ字で示す */}
          <span className="MyPage-password_mask" aria-label="設定済み">
            ••••••••
          </span>
          <Button type="button" color="white" mini={true} onClick={() => history.push('/password/edit')}>
            変更
          </Button>
        </dd>
      </dl>
      <div className="MyPage-logout">
        <LogoutButton />
      </div>
    </div>
  );
};
